import { render, staticRenderFns } from "./BaskoNextGenCategory.vue?vue&type=template&id=eb19fee2"
import script from "./BaskoNextGenCategory.vue?vue&type=script&lang=js"
export * from "./BaskoNextGenCategory.vue?vue&type=script&lang=js"
import style0 from "./BaskoNextGenCategory.vue?vue&type=style&index=0&id=eb19fee2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports